import { render, staticRenderFns } from "./edit_employee.vue?vue&type=template&id=5b37d998&scoped=true&"
import script from "./edit_employee.vue?vue&type=script&lang=js&"
export * from "./edit_employee.vue?vue&type=script&lang=js&"
import style0 from "./edit_employee.vue?vue&type=style&index=0&id=5b37d998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37d998",
  null
  
)

export default component.exports